import { EXPLORE_ROUTES } from "./exploreRoutes";
import { DASHBOARD_ROUTES } from "./dashboardRoutes";
import React, { useRef } from "react";
import "./ChooseState.css";
import { useNavigate } from "react-router-dom";
import LogoIcon from "../assets/images/SliderLogo.png";
import starIcon from "../assets/images/bookmark.png";
import useDashboardRowDrag from "./useDashboardRowDrag";

const MAX_VISIBLE_STATES = 4;

const StateCardSkeleton = () => (
  <div className="state-card dashboard-skeleton dashboard-collection-skeleton" data-testid="dashboard-collection-skeleton" aria-hidden="true">
    <span className="dashboard-collection-skeleton__badge" />
    <span className="dashboard-collection-skeleton__details">
      <span className="dashboard-collection-skeleton__title" />
      <span className="dashboard-collection-skeleton__subtitle" />
    </span>
  </div>
);

const ChooseState = ({ states = [], isLoading = false, error = "" }) => {
  const navigate = useNavigate();
  const rowRef = useRef(null);
  useDashboardRowDrag(rowRef);
  const visibleStates = states.slice(0, MAX_VISIBLE_STATES);
  const handleOpenStateCategories = (state) => {
    if (!state?.state_id || Number(state?.is_disabled) === 1) {
      return;
    }

    navigate(EXPLORE_ROUTES.categories, {
      state: {
        state_id: Number(state.state_id),
        selectedState: {
          state_id: Number(state.state_id),
          state_name: state.state_name || "",
          capital_name: state.capital_name || "",
        },
      },
    });
  };

  return (
    <section className="quick-action dashboard-collection-section myexams-block" aria-labelledby="choose-state-title">
      <div className="dashboard-states">
          <div className="quick-action__header mobile-action-header">
            <h2 id="choose-state-title" className="quick-action__title">
              Choose State
            </h2>

            <div className="quick-action__actions mobile-action">
              {!isLoading ? (
                <>
                  <button
                    type="button"
                    className="quick-action__add-state"
                    aria-label="Add State"
                    onClick={() => navigate(DASHBOARD_ROUTES.states)}
                  >
                    <span className="quick-action__add-icon">
                      <i className="fa-solid fa-plus"></i>
                    </span>

                    <span className="quick-action__add-text">Add State</span>
                  </button>

                  <button
                    type="button"
                    className="quick-action__see-all"
                    onClick={() => navigate(DASHBOARD_ROUTES.states)}
                  >
                    See All
                  </button>
                </>
              ) : (
                <>
                  <span className="dashboard-skeleton dashboard-collection-skeleton__add" aria-hidden="true" />
                  <span className="dashboard-skeleton dashboard-collection-skeleton__see-all" aria-hidden="true" />
                </>
              )}
            </div>
          </div>

        {!isLoading && error ? <p className="choose-state__status choose-state__status--error">{error}</p> : null}
        {!isLoading && !error && visibleStates.length === 0 ? (
          <p className="choose-state__status">No states available.</p>
        ) : null}

        <div ref={rowRef} className="choose-state__gridn dashboard-drag-row" role="region" aria-label="Choose State cards" aria-busy={isLoading} tabIndex={0}>
          {isLoading ? Array.from({ length: MAX_VISIBLE_STATES }).map((_, index) => (
            <div key={index} aria-hidden="true">
              <StateCardSkeleton />
            </div>
          )) : null}
          {!isLoading && !error ? visibleStates.map((item) => (
              <div key={item.state_id}>
                <div
                  className={`state-card${Number(item.is_disabled) ? " choose-state__card--disabled" : ""}${Number(item.is_disabled) ? "" : " subject-info-card--clickable"}`}
                  onClick={() => handleOpenStateCategories(item)}
                  onKeyDown={(event) => {
                    if (Number(item.is_disabled)) {
                      return;
                    }

                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      handleOpenStateCategories(item);
                    }
                  }}
                  role={Number(item.is_disabled) ? undefined : "button"}
                  tabIndex={Number(item.is_disabled) ? undefined : 0}
                >
                  <img src={item.state_image} className="state-bg" alt={item.state_name} />

                  <div className="state-badge">
                    <img src={LogoIcon} alt="" />
                  </div>

                  {Number(item.is_favourite) === 1 ? (
                    <div className="state-star">
                      <img src={starIcon} alt="Favorite state" />
                    </div>
                  ) : null}

                  {Number(item.is_user_state) === 1 ? (
                    <div className="state-tick">
                      <i className="fa-solid fa-check"></i>
                    </div>
                  ) : null}

                  <div className="state-content">
                    <h5>{item.state_name}</h5>
                    {item.capital_name ? <p>({item.capital_name})</p> : null}
                  </div>

                  {Number(item.is_disabled) === 1 ? (
                    <div className="choose-state__disabled-tag">Disabled</div>
                  ) : null}
                </div>
              </div>
            )) : null}
        </div>
      </div>
    </section>
  );
};

export default ChooseState;
